import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { formatDateBr } from '@core/utils/filter';
import SLSTipoEnderecoService from '@/services/Cadastros/Gerais/tipoendereco.service';
// Notification
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default function useTipoEnderecoList(nameModule) {
  // Use toast
  const toast = useToast();
  const sLSTipoEnderecoService = new SLSTipoEnderecoService();
  const refTipoEnderecoListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    { key: 'tipoenderecoid', label: 'Codigo', sortable: true },
    { key: 'tipoenderecodescricao', label: 'Descricao', sortable: true },
    { key: 'tipoenderecodefault', label: 'Obrigatorio', sortable: true },
    { key: 'actions', label: 'Ações' },
  ];
  const perPage = ref(10);
  const totalTipoEndereco = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref('');
  const searchIdPais = ref(null);
  const searchIdUf = ref(null);
  const sortBy = ref('tipoenderecoid');
  const isSortDirDesc = ref(false);
  const overlay = ref(true);
  const statusFilter = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refTipoEnderecoListTable.value ? refTipoEnderecoListTable.value.localItems.length : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalTipoEndereco.value,
    };
  });

  const refetchData = () => {
    refTipoEnderecoListTable.value.refresh();
  };

  watch([currentPage, perPage, searchQuery, searchIdPais, searchIdUf, statusFilter], () => {
    refetchData();
  });

  const fetchTipoEndereco = (ctx, callback) => {
    overlay.value = true;
    sLSTipoEnderecoService.index({
      q: searchQuery.value,
      id_pais: searchIdPais.value,
      id_uf: searchIdUf.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      fullObject: true,
    }).then((response) => {
      const { data, total } = response;
      overlay.value = false;
      // console.log(data);
      callback(data);
      perPage.value = response.perPage;
      currentPage.value = response.page;
      totalTipoEndereco.value = total;
    })
      .catch((error) => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching users list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      });
  };

  const create = async (body) => {
    await sLSTipoEnderecoService.store(body);
    refetchData();
  };
  const Updated = async (body) => {
    await sLSTipoEnderecoService.update(body.tipoenderecoid, body);
    refetchData();
  };

  const removerData = async (id) => {
    await sLSTipoEnderecoService.destroy(id);
    refetchData();
  };

  const resolveTypeFieldText = type => {
    if (type === 'VARCHAR') return 'Texto';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'Data';
    if (type === 'DATETIME') return 'Data e Hora';
    if (type === 'DECIMAL') return 'Monetário';
    if (type === 'TEXT') return 'Texto Longo';
    if (type === 'INTEGER' || type === 'INT') return 'Númerico';
    return 'Sem Tipo';
  };
  const resolveTypeFieldIcon = type => {
    if (type === 'VARCHAR') return 'tabler:abc';
    if (type === 'BOOLEAN') return 'Verdadeiro/Falso';
    if (type === 'DATE') return 'system-uicons:calendar-date';
    if (type === 'DATETIME') return 'formkit:datetime';
    if (type === 'TEXT') return 'mdi:text-long';
    if (type === 'DECIMAL') return 'tabler:decimal';
    if (type === 'DECIMAL' || type === 'INTEGER' || type === 'INT') return 'tabler:123';
    return 'nonicons:type-16';
  };

  const resolveItemStatusVariant = (status) => {
    if (status === 'PENDING') return 'light-warning';
    if (status === 'ATIVO') return 'light-success';
    if (status === 'INATIVO') return 'light-danger';
    return 'primary';
  };

  return {
    fetchTipoEndereco,
    tableColumns,
    perPage,
    currentPage,
    totalTipoEndereco,
    dataMeta,
    perPageOptions,
    searchQuery,
    searchIdUf,
    searchIdPais,
    sortBy,
    isSortDirDesc,
    refTipoEnderecoListTable,
    overlay,
    resolveTypeFieldText,
    resolveTypeFieldIcon,
    resolveItemStatusVariant,
    refetchData,
    create,
    Updated,

    // Extra Filters
    statusFilter,
    removerData,
  };
}
